import { Injectable } from '@angular/core';
import amplitude from 'amplitude-js';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../core/services/auth.service';
import {skip} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  public amplitude: any = null;
  private initializationStarted = false;
  private userProperties: IAmplitudeUserData|null = null;

  constructor(
    private auth: AuthService
  ) {
    this.setIdentityFromPayload(this.auth.payload);
  }

  protected init() {
    if (this.initializationStarted) {
      return;
    }
    setTimeout(() => {
      if (!this.amplitude) {
        console.warn('amplitude initialization failed');
      }
    }, 10000);
    this.initializationStarted = true;
    this.amplitude = amplitude.getInstance();
    this.amplitude.init(environment.amplitudeKey);
    if (this.userProperties) {
      this.amplitude.setUserProperties(this.userProperties);
    }
  }

  /**
   * @see https://developers.amplitude.com/docs/tracking-events
   */
  public logEvent(eventID: string, properties: any = {}) {
    if (!this.amplitude) {
      this.init();
      setTimeout(() => {
        this.logEvent(eventID);
      }, 500);
      return;
    }
    this.amplitude.logEvent(eventID, properties);
  }

  public setIdentityFromPayload(payload: IAuthorizationPayload) {
    if (!payload) {
      return;
    }
    this.setIdentity({
      user_id: payload.login
    });
  }

  public setIdentity(data: IAmplitudeUserData) {
    this.userProperties = data;
    if (this.amplitude) {
      this.amplitude.setUserProperties(this.userProperties);
    }
  }

  public logSignupEvent() {
    this.logEvent('Signup');
  }

  public logSigninEvent() {
    this.logEvent('Signin');
  }

  public logOpenSectionEvent(properties: IAmplitudeSectionEvent) {
    this.logEvent('Open section', properties);
  }

  public logRequestProcessedEvent(properties: IAmplitudeRequestProceedEvent) {
    this.logEvent('Request processed', properties);
  }
}
